export const enum EMeasurementType {
  COMMON_LEVEL = 'COMMON_LEVEL',
  SIGNAL = 'SIGNAL',
  SPECTER = 'SPECTER',
  TEMPERATURE = 'TEMPERATURE',
  RS = 'RS',
  RD = 'RD', // Изменение частоты вращения.
  TSR = 'TSR',
  TSRD = 'TSRD',
  TSTM = 'TSTM',
  OCTAVE = 'OCTAVE',
  ENVELOPE_SIGNAL = 'ENVELOPE_SIGNAL',
  ENVELOPE_SPECTER = 'ENVELOPE_SPECTER'
}
